// src/config.ts — single source of truth for runtime config.

/** Backend REST API base URL. Override via REACT_APP_API_URL. */
export const API_BASE =
  process.env.REACT_APP_API_URL ?? 'http://localhost:5000/api';

/** Static assets origin (backend root without the trailing /api). */
export const STATIC_ORIGIN = API_BASE.replace(/\/api\/?$/, '');
